import { ifProp, prop, switchProp } from 'styled-tools';
import styled from 'styled-components';
import bp from 'Styles/breakpoints';

const COMMON_LIST_STYLES = `
  column-gap: 100px;
  margin-left: 18px;

  li ul {
    margin-left: 18px;
  }
`;

const List = styled.ul`
  display: inline-block;

  &:last-child {
    margin-bottom: 0;
  }

  & > :last-child {
    margin-bottom: 0;
  }

  & > ul,
  & > ol {
    margin-bottom: 0;
  }

  ${switchProp(
    ifProp({ as: 'ol' }, 'ordered', prop('$bulletType', 'checkmark')),
    {
      checkmark: `
        li:before {
          content: '\\F015';
          font-family: var(--icon-font); /* stylelint-disable font-family-no-missing-generic-family-keyword */
          font-size: 0.9em;
          height: 0.9em;
          left: 0;
          position: absolute;
          top: 0.1em;
          width: 0.9em;
        }

        li {
          padding-left: 1.25em;
          position: relative;
        }

        ${bp('large')} {
          margin: 0 auto;
        }
      `,
      'default bullet': `
        list-style: disc;
        ${COMMON_LIST_STYLES}

        ul,
        ol {
          list-style-type: circle;
        }

        ul ul,
        ol ol {
          list-style-type: square;
        }
      `,
      ordered: `
        list-style: decimal;
        ${COMMON_LIST_STYLES}

        ul,
        ol {
          list-style-type: lower-latin;
        }

        ul ul,
        ol ol {
          list-style-type: lower-roman;
        }

        ul ul ul,
        ol ol ol {
          list-style-type: upper-latin;
        }
      `
    }
  )}

  li {
    & > p:only-child {
      margin-bottom: 0;
    }
  }

  ${bp('large')} {
    display: block;
    ${({ $listItems = 0, $columnType = 'two column' }) =>
      $columnType === 'two column' && $listItems > 3
        ? ' columns: auto 2;'
        : ' columns: auto 1;'}
  }
`;

export default List;
